module.exports = __webpack_public_path__ + "img/kinpin-logo-text.9ae47825.svg";